module.exports = __webpack_public_path__ + "img/document_app_essential_icon.b25ddcd9.svg";